/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { type FC } from 'react';
import type { TransportData } from '@/domainLogic/index.ts';
import { useCommonClient } from '@/app/common/commonClientProvider';
import type { Dates } from '@/app/components/search/utils';
import type { ClickParams } from '@/app/components/search/Curiosity/Analytics/utils';
import MonthContainer from './MonthContainer';

export type MonthsProps = {
  month: number;
  year: number;
  dates?: Dates;
  setMonth: React.Dispatch<React.SetStateAction<number>>;
  setYear: React.Dispatch<React.SetStateAction<number>>;
  setDates: React.Dispatch<React.SetStateAction<Dates | undefined>>;
  i: number;
  containerRef: React.RefObject<HTMLDivElement | null>;
  eventCallback: (payload: ClickParams) => void;
  disableDatesOutsideBookingWindow: boolean;
  transportData: TransportData[] | undefined;
};

const Months: FC<MonthsProps> = ({
  month,
  year,
  dates,
  setMonth,
  setYear,
  setDates,
  containerRef,
  eventCallback,
  disableDatesOutsideBookingWindow,
  transportData,
}) => {
  const { isMobile } = useCommonClient();
  const monthsToDisplay = isMobile ? 11 : 1;
  const navArrowPropsCommon = {
    setMonth,
    setYear,
    firstMonth: { month, year },
    eventCallback,
  };

  const items: any = [];
  for (let i = 0; i <= monthsToDisplay; i++) {
    const date = new Date(year, month);
    const datePlusOne = new Date(date.setMonth(date.getMonth() + i));
    const nextMonth = datePlusOne.getMonth();
    const nextYear = datePlusOne.getFullYear();
    const navArrowProps = { direction: i === 0 ? 'left' : 'right', ...navArrowPropsCommon };

    const monthYear =
      i === 0
        ? {
            month,
            year,
            setDates,
            dates,
            containerRef,
            disableDatesOutsideBookingWindow,
            transportData,
          }
        : {
            month: nextMonth,
            year: nextYear,
            setDates,
            dates,
            containerRef,
            disableDatesOutsideBookingWindow,
            transportData,
          };
    const monthsItemModel = <MonthContainer key={`month-container-${i}`} {...{ navArrowProps, monthYear, isMobile }} />;
    items.push(monthsItemModel);
  }

  return items;
};

export default Months;
